import React from 'react'

type Props = React.SVGProps<SVGSVGElement>

export function AlertDuotone(props: Props) {
  return (
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M7 14C10.866 14 14 10.866 14 7C14 3.13401 10.866 0 7 0C3.13401 0 0 3.13401 0 7C0 10.866 3.13401 14 7 14Z"
        fill="#B3B6FD"
      />
      <path
        d="M6.99902 9.85449C7.26147 9.85449 7.43699 9.90793 7.54199 10.0156C7.64699 10.1234 7.69922 10.2675 7.69922 10.4111V10.6445C7.69919 10.788 7.64677 10.9314 7.54199 11.0391C7.43699 11.1468 7.26152 11.2012 6.99902 11.2012C6.73669 11.2011 6.56199 11.1468 6.45703 11.0391C6.35212 10.9314 6.29983 10.806 6.2998 10.6445V10.4111C6.2998 10.2495 6.35203 10.1234 6.45703 10.0156C6.57945 9.90808 6.73689 9.85453 6.99902 9.85449ZM6.82422 2.81543C7.48906 2.70771 8.04857 3.22779 8.04883 3.87402V3.96387C7.92635 5.0052 7.82178 6.02898 7.7168 7.07031L7.31445 8.88477C7.27937 9.02829 7.15643 9.13574 6.99902 9.13574C6.84162 9.13565 6.71956 9.02776 6.68457 8.86621L6.28125 7.05273C6.15876 6.01129 6.05421 4.98773 5.94922 3.94629C5.94923 3.40761 6.29926 2.90524 6.82422 2.81543Z"
        fill="#2C32C1"
      />
    </svg>
  )
}
